import type { InjectionKey } from 'vue'

/**
 * Used in the signup init module to avoid drilling the noFloat prop up to other children
 * For now noFloat is only used for the referral redirection flow.
 */
export const noFloatInjectKey = Symbol() as InjectionKey<boolean>
